import {ConfigService} from './config.service';
import {Mensagem} from '../mensagem/Mensagem';
import ToastService from '../../../vendors/services/toastService';

export class Interceptors {

  public static requestInterceptor = (request: any) => {
    const headers = request.headers;
    const actualHeaders = ConfigService.getHeaders();

    if (actualHeaders.headers.Authorization) {
      headers['Authorization'] = 'Bearer ' + actualHeaders.headers.Authorization;
    } else {
      headers['Authorization'] = '';
    }
    return request;
  };

  public static responseInterceptorSuccess(response: any) {
    return {
      result: response.data.result,
      success: response.data.success,
      msg: response.data.msg,
      data: response.data
    };
  }

  static responseInterceptorError(err: any): any {
    if (!err || !err.response) {
      return Promise.reject(err.response);
    }
    const response = err.response;
    const data = !!response.data && response.data.result && response.data.result.length > 0 ? response.data : {result: [Mensagem.FALHA_REQUISICAO]};
    const status = response.status;
    const skipAuthRedirect = !!(err.config && err.config.skipAuthRedirect);
    if (status === 400) {
      data.result.forEach((m: any) => ToastService.showWarn(m));
    } else if (status === 500) {
      data.result.forEach((m: any) => ToastService.showError(Mensagem.FALHA_REQUISICAO));
    } else if (status === 401 || status === 403) {
      if (skipAuthRedirect) {
        data.result.forEach((m: any) => ToastService.showError(m));
      } else {
        window.location.href = '/logout';
      }
    }
    return Promise.reject(err.response);
  }

  /**
   * Tratamento de erro para requisições públicas (rotas abertas). Não força o
   * redirecionamento para /logout em 401/403, permitindo consumo por usuários
   * deslogados sem quebrar a sessão.
   */
  static publicResponseInterceptorError(err: any): any {
    return Promise.reject(err?.response);
  }
}
